export const Footer = (props) => {
  return (
    <div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {new Date().getFullYear()} {props.data?.company} All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
